<template lang="pug">
div(class="tl-tooltip-container")
    div
        slot

    tl-position(
        x="end"
        y="center"
    )
        tl-tooltip(
            :left="left"
            :right="right"
            :tip="tip"
            :top="top"
        )
            i(
                class="mi-circle-information"
                style="font-size: 20px; opacity: 0.3"
            )
</template>

<script setup>
import { computed, inject } from 'vue'
import { getInjects } from '@/components/$tl/utils/injects'

const props = defineProps({
    tip: String,
    left: Boolean,
    top: Boolean,
    right: Boolean,
})

const injects = getInjects(props, inject)

const tip = computed(() => props.tip ?? injects.tip?.value)
const top = computed(() => props.top ?? injects.top?.value)
const left = computed(() => props.left ?? injects.left?.value)
const right = computed(() => props.right ?? injects.right?.value)
</script>

<style lang="sass" scoped>
.tl-tooltip-container
    display: grid
    grid-template-columns: 1fr 20px
    grid-gap: 20px
</style>
